import React from "react";

const AiRoomFooter = () => {
  return (
    <footer className="  footer-bot-meeting-room">
      <div className="meeting-room-log">
        <span className=" fw-bold text-decoration-none cursor-pointer">
          Need help?{" "}
        </span>{" "}
        info@niyantras.com
      </div>
    </footer>
  );
};

export default AiRoomFooter;
